import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AccredibleResponsiveMenuItem } from '../../models/responsive-menu.model';

@Component({
  selector: 'accredible-menu-item',
  templateUrl: 'menu-item.component.html',
  styleUrls: ['menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent {
  menuItem = input<AccredibleResponsiveMenuItem>();
  nonMenuItemRole = input<boolean>(false);
}
